import { DataGrid, getDefaultGridFilterModel } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import React, { useState, useEffect } from "react";
import MultiFilter from "./Multifilter";
import PropTypes from "prop-types";

const CustomToolbar = ({ onAddFilter, columns, component, leftComponent, showToolbar }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: {
                    xs: "flex-start",
                    md: "center"
                },
                justifyContent: "space-between",
                gap: 2
            }}
        >
            <Box sx={{ flex: "1 1 auto", minWidth: 0 }}>
                {leftComponent}
            </Box>
            {showToolbar && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: {
                            xs: "flex-start",
                            md: "center"
                        },
                        justifyContent: "flex-end",
                        gap: 2,
                        flexWrap: "wrap"
                    }}
                >
                    <MultiFilter onAddFilter={onAddFilter} columns={columns} />
                    {component}
                </Box>
            )}
        </Box>

    )
}

CustomToolbar.propTypes = {
    onAddFilter: PropTypes.func,
    columns: PropTypes.array,
    component: PropTypes.node,
    leftComponent: PropTypes.node,
    showToolbar: PropTypes.bool,
};
  const DefaultNoRowsOverlay = () => {

        return (
            <Box sx={{
                display: 'flex', justifyContent: 'center',
                alignItems: 'center', margin: 2,
                fontSize: "20px"
            }}
            >
                There are no items to show
            </Box>
        )
    }
const Table = (props) => {




    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 100
    });
    const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
    const [sortModel, setSortModel] = useState();
    const [filterModel, setFilterModel] = useState(getDefaultGridFilterModel());
    const [filteredData, setFilteredData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [dynamicFilters, setDynamicFilters] = useState([]);
    const isSelectionControlled = props.rowSelectionModel !== undefined;
    const effectiveRowSelectionModel = isSelectionControlled ? props.rowSelectionModel : rowSelectionModel;

    const handleApplyFilters = (filters) => {
        setDynamicFilters(filters);
    };



    useEffect(() => {
        let active = true;

        (async () => {
            if (props.setLoading !== undefined) {
                props.setLoading(true);
            }
            const newRows = await loadServerRows(paginationModel.page, paginationModel.pageSize, sortModel, filterModel, props.data, dynamicFilters);

            if (!active) {
                return;
            }

            setTableData(newRows);
            if (props.setLoading !== undefined) {
                props.setLoading(false);
            }
        })();

        return () => {
            active = false;
        };
    }, [paginationModel.page, paginationModel.pageSize, sortModel, filterModel, props.data, dynamicFilters]);


    function loadServerRows(page, size, sortModel, filterModel, data, dynamicFilters) {
        const operatorFunctions = {
            contains: (value, filter) => filter.value ? value.includes(filter.value.toLowerCase()) : true,
            doesNotContains: (value, filter) => filter.value ? !value.includes(filter.value.toLowerCase()) : true,
            equals: (value, filter) => value === filter.value?.toLowerCase(),
            notEquals: (value, filter) => value !== filter.value?.toLowerCase(),
            startsWith: (value, filter) => value.startsWith(filter.value?.toLowerCase()),
            endsWith: (value, filter) => value.endsWith(filter.value?.toLowerCase()),
            isEmpty: (value, filter) => value === '',
            isNotEmpty: (value, filter) => value !== '',
            isAnyOf: (value, filter) => {

                const filterValues = typeof filter.value === 'string'
                ? filter.value.split(',').map(item => item.trim().toLowerCase())
                : filter.value;

                return filterValues?.includes(value.toLowerCase());
            },

        };

        if (dynamicFilters.length > 0) {
            data = data.filter((row) => {
                return dynamicFilters.every((filter) => {
                    if (row.hasOwnProperty(filter.column)) {
                        let value = row[filter.column];
                        if (typeof value === 'string') {
                            value = value.toLowerCase();
                        } else {
                            value = String(value);
                        }
                        if (filter.operator in operatorFunctions) {
                            return operatorFunctions[filter.operator](value, filter);
                        }
                    }
                    return false;
                });
            });
        }

        // Apply server-side filters
        if (filterModel?.quickFilterValues?.length > 0 && filterModel.quickFilterValues[0]) {
            const str = filterModel.quickFilterValues[0].toLowerCase();
            data = data.filter(obj => {
                return Object.keys(obj).some(key => String(obj[key]).toLowerCase().includes(str));
            });
        }

        if (filterModel && filterModel.items.length > 0) {
            data = data.filter((row) => {
                return filterModel.items.every((filter) => {
                    if (row.hasOwnProperty(filter.field)) {
                        let value = row[filter.field];
                        if (typeof value === 'string') {
                            value = value.toLowerCase();
                        } else {
                            value = String(value);
                        }
                        if (filter.operator in operatorFunctions) {
                            return operatorFunctions[filter.operator](value, filter);
                        }
                    }
                    return false;
                });
            });
        }

        // Apply sorting
        if (sortModel && sortModel.length > 0) {
            const sortCol = sortModel[0].field;
            const sortOrder = sortModel[0].sort;
            data = data.sort((a, b) => {
                const aVal = a[sortCol];
                const bVal = b[sortCol];
                let comparison;
                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    comparison = sortOrder === 'asc' ? aVal - bVal : bVal - aVal;
                } else {
                    comparison = sortOrder === 'asc'
                        ? String(aVal).toLowerCase().localeCompare(String(bVal).toLowerCase())
                        : String(bVal).toLowerCase().localeCompare(String(aVal).toLowerCase());
                }
                return comparison;
            });
        }
        if (props.onFilteredDataChange) {
            props.onFilteredDataChange(data);
          }
        setFilteredData(data);
        return data.slice(page * size, (page + 1) * size);
    }

    return (
        <Box sx={{
            // height: 400, 
            width: "100%",
            // gap: 2,
            backgroundColor: "white",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            padding: "1rem",

            borderRadius: "12px",
            '& .no-active-border': {
                "&:focus-within": {
                    outline: "none",
                    border: "0px solid transparent",
                    boxShadow: "0px 0px 0px transparent",
                },
            },
        }}
        >


            <DataGrid
                {...props}
                
                getRowId={(row) => row.id || row.serialnumber || row.application_number}


                initialState={{
                    ...props.initialState,
                    //     pagination: {
                    //         paginationModel: {
                    //             pageSize: 10
                    //         }
                    //     }
                }}
                // loading={loading}

                rows={tableData}
                pagination
                pageSizeOptions={[10, 20, 50, 100]}
                paginationModel={paginationModel}
                rowCount={filteredData?.length}
                paginationMode="server"
                filterMode="server"
                sortingMode="server"
                sortModel={sortModel}
                filterModel={filterModel}
                slots={{
                    toolbar: CustomToolbar,
                    noRowsOverlay: props?.noRowsOverlay || DefaultNoRowsOverlay
                }}
                slotProps={{
                    toolbar: {
                        columns: props.columns,
                        onAddFilter: handleApplyFilters,
                        leftComponent: props.showToolbar && props.toolbarLeftComponent ? <props.toolbarLeftComponent /> : null,
                        component: props.showToolbar ? <props.customToolbar /> : null,
                        // showMultiFilter,
                        showToolbar: props.showToolbar
                    }
                }}
                onSortModelChange={async (newSortModel) => setSortModel(newSortModel)}
                onFilterModelChange={async (newFilterModel) => setFilterModel(newFilterModel)}
                keepNonExistentRowsSelected
                onPaginationModelChange={setPaginationModel}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    if (!isSelectionControlled) {
                        setRowSelectionModel(newRowSelectionModel);
                    }
                    if (props.onRowSelectionModelChange) {
                        props.onRowSelectionModelChange(newRowSelectionModel); //notify parent
                    }
                }}
                rowSelectionModel={effectiveRowSelectionModel}
                autoHeight
            />
        </Box>
    );
};


Table.propTypes = {
    columns: PropTypes.array,
    data: PropTypes.array,
    setLoading: PropTypes.func,
    rowSelectionModel: PropTypes.array,
    onRowSelectionModelChange: PropTypes.func,
    onFilteredDataChange: PropTypes.func,
    showToolbar: PropTypes.bool,
    toolbarLeftComponent: PropTypes.elementType,
    noRowsOverlay: PropTypes.elementType,
    initialState: PropTypes.object, // <-- Added prop validation
};

export default Table;